import { isUndefined } from 'lodash';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

const arrayPersonRenderType = 'arrayPerson';
const fileRenderType = 'file';

export const gridRenderList = [arrayPersonRenderType];

// Special builder for a person object generated via ArrayPersonForm
function arrayPersonBuilder(configSchema, store) {
  // Get display values array from license data
  const arrayFromStore = get(store, configSchema.arrayKey, []);

  /**
   * 1. Iterate thru the list from the data store
   * 2. Retrieve values from the the list and merge with the
   *    template provided from the "licenseInfoRenderConfig" JSON
   */
  return arrayFromStore.map((el, cIDX) =>
    configSchema.data.map((ele) => ({
      ...ele,
      dataKey: `${configSchema.arrayKey}[${cIDX}].${ele.key}`,
      content: get(el, ele.key),
    }))
  );
}

function fileBuilder(configSchema, store) {
  if (!store.images.length) return null;

  const docTypeFileMap = {};
  store.images.forEach((image, idx) => {
    const docsInMap = docTypeFileMap[image.documentType];
    const struct = { ...image, dataKey: `${image.documentType}_${idx}` };

    if (isUndefined(docsInMap)) docTypeFileMap[image.documentType] = [struct];
    else docTypeFileMap[image.documentType].push(struct);
  });

  Object.keys(docTypeFileMap).forEach((type) => {
    docTypeFileMap[type] = docTypeFileMap[type].sort(
      (a, b) => new Date(a.uploadDate) - new Date(b.uploadDate)
    );
  });

  const config = configSchema.fileTypes.map((type) => ({
    component: configSchema.component,
    dataKey: type,
    label: configSchema.fileLabelMap[type],
    fileList: docTypeFileMap[type] || [],
  }));

  return config;
}

function defaultBuilder(configSchema, store) {
  /**
   * 1. Iterate thru the config for the sub-section
   * 2. Retrieve values from the data store and merge with the
   *    template provided from the "licenseInfoRenderConfig" JSON
   */
  return configSchema.data
    .map((el) => ({
      ...el,
      content: get(store, el.dataKey),
      label: get(store, el.labelKey, el.label),
    }))
    .filter(
      (el) => !isNil(el.content) || (!isNil(el.label) && el.allowEmptyValues)
    );
}

export function builder(configSchema, store) {
  switch (configSchema.type) {
    case fileRenderType:
      return fileBuilder(configSchema, store);
    case arrayPersonRenderType:
      return arrayPersonBuilder(configSchema, store);
    default:
      return defaultBuilder(configSchema, store);
  }
}
